/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_ChannelInputs */

const en_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption channel`)
};

const fr_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaîne de sous-titres`)
};

const de_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelkanal`)
};

const it_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canale dei sottotitoli`)
};

const ru_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Канал субтитров`)
};

const es_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal de subtítulos`)
};

const zh_cn2_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕频道`)
};

const ja_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕チャンネル`)
};

const hi_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन चैनल`)
};

const pt_pt2_live_caption_channel = /** @type {(inputs: Live_Caption_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal de legendas`)
};

/**
* | output |
* | --- |
* | "Caption channel" |
*
* @param {Live_Caption_ChannelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_channel = /** @type {((inputs?: Live_Caption_ChannelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_ChannelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_channel(inputs)
	if (locale === "de") return de_live_caption_channel(inputs)
	if (locale === "it") return it_live_caption_channel(inputs)
	if (locale === "ru") return ru_live_caption_channel(inputs)
	if (locale === "es") return es_live_caption_channel(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_channel(inputs)
	if (locale === "ja") return ja_live_caption_channel(inputs)
	if (locale === "hi") return hi_live_caption_channel(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_channel(inputs)
	return en_live_caption_channel(inputs)
});